import {Injectable, Inject, forwardRef, ApplicationRef, Injector} from '@angular/core';
import {AppComponent} from './app.component';
import {ErrorHandler} from "@angular/core";
import {NgModule} from "@angular/core";
import {ActivatedRouteSnapshot, DetachedRouteHandle, Router, RouteReuseStrategy} from "@angular/router";

let hasRouterError = false;
@Injectable()
export class AppExceptionHandler implements ErrorHandler {

    constructor(private inj: Injector) {
    }

    static appComponent: AppComponent;

    handleError(error) {

        /*        var errorMsg = "";

         if (typeof error !== 'undefined') {
         errorMsg = error;
         }
         else {
         errorMsg = "Ismeretlen hiba";
         }

         try {
         $.growl.error({
         title: "Hiba!",
         message: errorMsg
         });
         } catch (e) {
         alert("Hiba! " + errorMsg);
         }
         */
        /*
         setTimeout(function () {
         AppExceptionHandler.lastError = null;
         }, 1000);*/

        enableUser();

        /*
         if(hasRouterError) {
         let router = this.inj.get(Router);
         router.navigated = false;
         }
         else {*/
        AppRouterErrorHandler(error);
        //}

        /*

         console.log(error);
         alert('Hiba: ' + error);
         enableUser(); */

        /*
         try {
         AppExceptionHandler.appComponent.showMsgDialog('Hiba!', errorMsg + " - " + stackTrace);
         } catch (e)
         {
         alert(errorMsg + " - " + stackTrace);
         }*/
    }
}
@NgModule({
    providers: [{provide: ErrorHandler, useClass: AppExceptionHandler}]
})
export class AppExceptionHandlerModule {
}

export function AppRouterErrorHandler(error: any) {
    console.log(error);
    var errorMsg = "";

    if (typeof error !== 'undefined') {
        if (typeof error['status'] !== 'undefined') {
            if (error.status == 0) {
                errorMsg = "Kommunikációs hiba a szerverrel, kérem próbálja újra!";
            }
            else {
                errorMsg = error;
            }
        }
    }
    else {
        errorMsg = "Ismeretlen hiba";
    }

    try {
        $.growl.error({
            title: "Hiba!",
            message: errorMsg
        });
    } catch (e) {
        alert("Hiba! " + errorMsg);
    }

    hasRouterError = true;
    //throw error;
}

@Injectable()
export class AppPreventErrorRouteReuseStrategy implements RouteReuseStrategy {
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        return null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        if (hasRouterError) {
            hasRouterError = false;
            return false;
        }
        return future.routeConfig === curr.routeConfig;
    }
}
@NgModule({
    providers: [{provide: RouteReuseStrategy, useClass: AppPreventErrorRouteReuseStrategy}]
})
export class AppPreventErrorRouteReuseStrategyModule {
}
